import VsCompare from "./VsCompare";

export default function VsWiseAgent() {
  return (
    <VsCompare
      competitor="Wise Agent"
      testId="vs-wa-page"
      slug="wise-agent"
      seoTitle="iKEY vs. Wise Agent — AI Briefings & DocuSign Included"
      seoDescription="Compare iKEY and Wise Agent for solo agents. iKEY adds AI 'who to call' briefings, DocuSign, and a native mobile app on top of every plan."
      tagline="Wise Agent is a CRM. iKEY is a CRM plus everything an agent uses after the lead."
      rows={[
        { label: "Free forever tier",             ikey: true,                    them: "14-day trial only" },
        { label: "E-signatures included",         ikey: "DocuSign built-in",     them: "Bring your own DocuSign" },
        { label: "Branded client portal",         ikey: true,                    them: false },
        { label: "AI 'Who to call today' briefing", ikey: true,                  them: false },
        { label: "Native iOS + Android app",      ikey: true,                    them: "Web-only mobile view" },
        { label: "Transaction deadline tracker",  ikey: true,                    them: "Add-on module" },
        { label: "CSV data export on Free",       ikey: true,                    them: "No free tier" },
      ]}
      pricing={[
        { tier: "Free",             ikey: "$0 · 1–3 clients (CRM only)",     them: "No free tier · 14-day trial" },
        { tier: "Entry paid tier",  ikey: "$39.99/mo · Growth · 10 clients", them: "$49/mo · Solo" },
        { tier: "Mid-tier",         ikey: "$79.99/mo · Master · 20 clients",   them: "$79/mo · Enterprise (multi-user)" },
        { tier: "Top tier",         ikey: "$119.99/mo · Pro · unlimited",    them: "$79/mo (cap = seats)" },
        { tier: "DocuSign add-on",  ikey: "Included in every paid plan",     them: "$45–$85/mo extra (DocuSign)" },
      ]}
      chooseIkeyWhen={[
        "You want AI in your CRM, not just a database — iKEY's Run-My-Day tells you who to call and drafts the opener; Wise Agent doesn't.",
        "You want a native iOS + Android app — Wise Agent's mobile is a browser view, iKEY is a real Expo/native build.",
        "You want e-signatures without a $45–$85/mo DocuSign line-item — every paid iKEY plan includes DocuSign.",
        "You want a branded client portal your buyers actually log into — iKEY ships one on every plan; Wise Agent doesn't.",
        "You want to start free with real data, not a 14-day trial that resets your workflow when it expires.",
      ]}
      faq={[
        {
          q: "Can I migrate my Wise Agent data into iKEY?",
          a: "Yes. Wise Agent exports leads and contacts to CSV; drop the file into iKEY's Import CSV screen on the Leads page and everything imports in one pass.",
        },
        {
          q: "Does iKEY support Wise Agent's drip campaigns?",
          a: "iKEY replaces drip campaigns with an AI briefing: the Run-My-Day screen surfaces the highest-signal outreach every morning and drafts personalized openers, instead of firing scheduled email blasts.",
        },
        {
          q: "Is iKEY's DocuSign the real DocuSign?",
          a: "Yes — the same DocuSign envelopes, certificates, and audit trail; you just don't manage a separate DocuSign subscription.",
        },
        {
          q: "How much cheaper is iKEY over a year?",
          a: "Wise Agent Solo ($49/mo) plus DocuSign Standard ($45/mo) is about $1,128/year. iKEY Growth is $479.88/year — roughly $648 saved. Annual billing on iKEY drops that another 18%.",
        },
      ]}
    />
  );
}
